import { Plane, Users } from "lucide-react";

const OPTIONS = [
  ["user", "Traveler", Plane, "7 days free · $9.99/mo · 2 devices"],
  ["family", "Family", Users, "10 days free · $19.99/mo · 5 devices"],
];

export function PlanChoice({ plan, setPlan }) {
  return (
    <div className="grid grid-cols-2 gap-2">
      {OPTIONS.map(([id, label, Icon, sub]) => (
        <button key={id} type="button" data-testid={`plan-${id}-option`} onClick={() => setPlan(id)}
          className={`rounded-2xl border p-3 text-left transition-colors ${plan === id ? "border-[#00E5A3] bg-[#00E5A3]/10" : "border-[#26334D] hover:border-slate-500"}`}>
          <span className="flex items-center gap-1.5 text-sm font-semibold"><Icon className="h-4 w-4 text-[#00E5A3]" /> {label}</span>
          <span className="block text-[11px] text-slate-400 mt-1">{sub}</span>
        </button>
      ))}
    </div>
  );
}
